var jq = jQuery.noConflict(true);

jq(function(){
    updateSwiper();
})

jq(window).resize(function(){
    updateSwiper();
})

function updateSwiper(){

    jq(".custom-list-swiper").each(function(){
      if(jq(window).width() < 750){
        jq(this).attr("slides-per-view", jq(this).attr("data-mob"));
      }
      else{
        jq(this).attr("slides-per-view", jq(this).attr("data-desk"));
      }
    })
    if(jq(window).width() < 990){
        jq(".custom-feed-swiper").attr("slides-per-view", 3);
    }
    else{
        jq(".custom-feed-swiper").attr("slides-per-view", 6);
    }

    if(jq(window).width() < 750){
      jq(".custom-logos-slider-swiper").attr("slides-per-view", 3);
      
      jq(".custom-card-swiper").attr("slides-per-view", 1.2);
      jq(".custom-card-swiper").attr("loop", "true");
      jq(".custom-card-swiper").attr("centered-slides", "true");

      jq(".custom-testimonial-2-swiper").attr("slides-per-view", 1.1);
      jq(".custom-testimonial-2-swiper").attr("space-between", 10);

      jq(".custom-main-product-media-thumb-swiper").attr("slides-per-view", 5);
      if(jq(".custom-main-product-media-swiper").hasClass("custom-main-product--show-dots")){
        jq(".custom-main-product-media-swiper").attr("pagination", "true");
        jq(".custom-main-product-media-swiper").attr("pagination-clickable", "true");
      }
    }
    else{
      jq(".custom-logos-slider-swiper").attr("slides-per-view", 4);

      jq(".custom-card-swiper").attr("slides-per-view", 3);
      jq(".custom-card-swiper").removeAttr("loop");
      jq(".custom-card-swiper").removeAttr("centered-slides");

      jq(".custom-testimonial-2-swiper").attr("slides-per-view", 3);
      jq(".custom-testimonial-2-swiper").attr("space-between", 40);

      jq(".custom-main-product-media-thumb-swiper").attr("slides-per-view", 7.5);
      if(jq(".custom-main-product-media-swiper").hasClass("custom-main-product--show-dots")){
        jq(".custom-main-product-media-swiper").removeAttr("pagination", "true");
        jq(".custom-main-product-media-swiper").removeAttr("pagination-clickable", "true");
      }
    }

    if(jq(window).width() <= 550){
        jq(".custom-reviews-swiper").attr("slides-per-view", 1);
        console.log("1280")
    }
    else if(jq(window).width() <= 749){
        jq(".custom-reviews-swiper").attr("slides-per-view", 2);
        console.log("1024")
    }
    else if(jq(window).width() <= 989){
        jq(".custom-reviews-swiper").attr("slides-per-view", 1);
        console.log("989")
    }
    else if(jq(window).width() <= 1024){
        jq(".custom-reviews-swiper").attr("slides-per-view", 2);
        console.log("749")
    }
    else if(jq(window).width() <= 1280){
        jq(".custom-reviews-swiper").attr("slides-per-view", 3);
        console.log("550")
    }
    else{
        jq(".custom-reviews-swiper").attr("slides-per-view", 4);
        console.log("else")
    }
}

jq(".custom-banner-video-button").click(function(){
  if(!jq(this).hasClass("active")){
    jq(this).addClass("active");
    jq(this).parent().find(".custom-banner-video").trigger("pause");
  }
  else{
    jq(this).removeClass("active");
    jq(this).parent().find(".custom-banner-video").trigger("play");
  }
})

jq(".custom-menu-title").click(function(){
  jq(this).toggleClass("active");
  jq(this).next(".custom-menu-item-list").slideToggle(300);
})

jq(".new-coll-header-item").click(function(){
  let id = jq(this).attr("data-id");
  jq(this).parent().find(".new-coll-header-item").removeClass("active");
  jq(this).parents(".new-coll").find(".new-coll-wrapper").removeClass("active");
  jq(this).parents(".new-coll").find(`.new-coll-wrapper[data-id="${id}"]`).addClass("active");
  jq(this).addClass("active");
})

jq(".custom-faq-block-title").click(function(){
    if(jq(this).parent().hasClass("active")){
        jq(this).parent().toggleClass("active");
        jq(this).next(".custom-faq-block-content").slideToggle(250);
    }
    else{
        jq(this).parents(".custom-faq-block-wrapper").find(".custom-faq-block").removeClass("active");
        jq(this).parents(".custom-faq-block-wrapper").find(".custom-faq-block-content").slideUp(250);
        jq(this).parent().addClass("active");
        jq(this).next(".custom-faq-block-content").slideDown(250);
    }
})

jq(".custom-acc-title-wrapper").click(function(){
  if(jq(this).hasClass("active")){
      jq(this).toggleClass("active");
      jq(this).next(".custom-acc-content").slideToggle(250);
  }
  else{
      jq(this).parents(".custom-acc-wrapper").find(".custom-acc-title-wrapper").removeClass("active");
      jq(this).parents(".custom-acc-wrapper").find(".custom-acc-content").slideUp(250);
      jq(this).addClass("active");
      jq(this).next(".custom-acc-content").slideDown(250);
  }
})

jq(".footer-block__heading").click(function(){
    if(jq(this).hasClass("active")){
        jq(this).toggleClass("active");
        jq(this).next(".footer-block__details-content").slideToggle(250);
    }
    else{
        jq(this).parents(".footer__blocks-wrapper").find(".footer-block__heading").removeClass("active");
        jq(this).parents(".footer__blocks-wrapper").find(".footer-block__details-content").slideUp(250);
        jq(this).addClass("active");
        jq(this).next(".footer-block__details-content").slideDown(250);
    }
});

jq(document).on("click", ".custom-cart-upsell-atc", function(){
    let arr = [];
    arr.push({ 'id': jq(this).attr("data-id"), 'quantity': 1 });
    AddUpsellToCart(arr, jq(this));
})

jq(".custom-hotspots-item").click(function(){
  jq(this).parent().find(".custom-hotspots-item").removeClass("active");
  jq(this).addClass("active");
  jq(this).parents(".custom-hotspots").find(".custom-hotspots-mobile-text").text(jq(this).find(".custom-hotspots-text").text());
})

jq(document).on("click", ".custom-addon-atc", function(){
  let arr = [];
  arr.push({ 'id': jq(this).attr("data-id"), 'quantity': 1 });
  AddUpsellToCart(arr, jq(this), true);
})

function AddUpsellToCart(productsArr, $this, open=false){
    $this.addClass("active");
    let formData = {
      'items': productsArr,
      sections: "cart-drawer,cart-icon-bubble"
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .then(res => {
      if(res.status){
        console.log(res);
      }
      else{
        const cartParsedData = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
        const cartBubbleParsedData = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
        jq("cart-drawer.drawer").removeClass("is-empty");
        jq(".drawer__inner").html(jq(cartParsedData).find(".drawer__inner").html());
        jq("#cart-icon-bubble").html(jq(cartBubbleParsedData).find(".shopify-section").html());
        if(open){
          document.querySelector("#cart-icon-bubble").dispatchEvent(new Event('click'));
          jq(".cart-count-bubble").trigger("click");
        }
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(() => {
      $this.removeClass("active");
    });
  }

  jq(document).on("click", ".custom-header-drawer-close", function(){
    jq(".header__icon--menu").trigger("click");
  })
  
  Fancybox.bind("[data-fancybox]", {});

  jq(".custom-main-product-swatch").hover(function(){
    jq(".custom-product-swatch-heading span").text(jq(this).attr("data-title"));
  }, function(){
    jq(".custom-product-swatch-heading span").text(jq(this).attr("data-d-title"));
  })

  jq(".new-faq-block-title").click(function(){
    if(jq(this).parent().hasClass("active")){
        jq(this).parent().toggleClass("active");
        jq(this).next(".new-faq-block-content").fadeToggle(200);
    }
    else{
        jq(this).parents(".new-faq-block-wrapper").find(".new-faq-block").removeClass("active");
        jq(this).parents(".new-faq-block-wrapper").find(".new-faq-block-content").hide();
        jq(this).parent().addClass("active");
        jq(this).next(".new-faq-block-content").fadeIn(200);
    }
  })

  jq(".new-faq-cat-list-item").click(function(){
    jq(".new-faq-block-wrapper").removeClass("active");
    jq(`.new-faq-block-wrapper[data-title=${jq(this).attr("data-title")}]`).addClass("active");
    jq(this).parent().find(".new-faq-cat-list-item").removeClass("active");
    jq(this).addClass("active");
  })

  jq(".new-cwl-item-thumb").click(function(e){
    e.preventDefault();
    e.stopPropagation();
    jq(this).parents(".new-cwl-item-img-wrapper").find(".new-cwl-item-img").attr("src", jq(this).attr("data-img"));
  });

  jq(".custom-mp-details-link").click(function(){
    if(jq(".custom-mp-details").length > 0){
      let top = jq(".custom-mp-details").offset().top;
      jq('html,body').animate({scrollTop: top}, 300);
    }
  })

  jq(".new-stabs-li").click(function(){
    jq(this).parent().find(".new-stabs-li").removeClass("active");
    jq(this).addClass("active");
    let title = jq(this).attr("data-title");
    jq(this).parents(".new-stabs-tab-wrapper").find(`.new-stabs-tab`).removeClass("active");
    jq(this).parents(".new-stabs-tab-wrapper").find(`.new-stabs-tab[data-title="${title}"]`).addClass("active")
  })